<template>
	<a
		href=""
		@click.prevent="share"
	 	rel="noopener noreferrer"
	>
		<svg
			width="7px"
			height="13px"
			viewBox="0 0 7 13"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
			<title>Fill 1</title>
			<desc>Created with Sketch.</desc>
			<g
				id="Symbols"
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
			>
				<g
					id="Icons/Social_2"
					transform="translate(-86.000000, -5.000000)"
					fill="#BCBFC6"
				>
					<path
						d="M90.4619909,17.7472682 L90.4619909,12.1407227 L92.4881727,12.1407227 L92.7910818,9.95435909 L90.4619909,9.95435909 L90.4619909,8.55981364 C90.4619909,7.92813182 90.6509909,7.49558636 91.6278091,7.49558636 L92.8731727,7.49558636 L92.8731727,5.54145 C92.6568091,5.51604091 91.9186273,5.45517727 91.0582636,5.45517727 C89.2611727,5.45517727 88.0304455,6.47390455 88.0304455,8.34354091 L88.0304455,9.95435909 L85.9998091,9.95435909 L85.9998091,12.1407227 L88.0304455,12.1407227 L88.0304455,17.7472682 L90.4619909,17.7472682 Z"
						id="Fill-1"
					></path>
				</g>
			</g>
		</svg>
	</a>
</template>

<script>
export default {
	methods:{
		share(){
			const url = encodeURIComponent(location.href)
			window.open(
			`https://www.facebook.com/sharer/sharer.php?u=${url}`, 
			'facebook-share-dialog', 
			'width=626,height=436'); 
			return false;
		}
	}
}
</script>